import { getStaticUrl } from '@anwb/poncho/utilities/browser';
import { DEV_PORT } from 'constants/devport';

export const LEGACY_CAR_SEARCH_PARAM_NAME = 'car';
export const LEASE_CAR_API_SEARCH_PARAM_NAME = 'carId';
export const LEASE_CAR_CONDITION_PARAM_NAME = 'condition';

export const NOT_AVAILABLE_ERROR_MESSAGE = 'Deze auto is helaas niet meer beschikbaar.';
export const DATA_MISSING_ERROR_MESSAGE =
	'Helaas is het op dit moment niet mogelijk om voor deze auto een aanvraag te doen.';
export const INVALID_URL_ERROR_MESSAGE = 'Er is helaas iets misgegaan.';

export const searchAndFilterPrivateLeaseUrl = (): string =>
	process.env.NODE_ENV === 'development'
		? 'http://localhost:8081/?app=privatelease' // The location when Z&F runs locally
		: '/auto/private-lease/anwb-private-lease/aanbod/';

export const searchAndFilterPrivateLeaseFlexUrl = (): string =>
	process.env.NODE_ENV === 'development'
		? 'http://localhost:8081/?app=privatelease/aanbod=flex'
		: '/auto/private-lease/anwb-private-lease/aanbod/aanbod=flex';

export const pdpWidgetCookiePath = () =>
	process.env.NODE_ENV === 'development' ? '/' : '/auto/private-lease';

export const staticAssetsUrl = (): string =>
	process.env.NODE_ENV === 'development'
		? `http://localhost:${DEV_PORT}`
		: `https://${DEV_PORT}.${getStaticUrl()}`;
